// extracted by mini-css-extract-plugin
export default {"wrapper":"XMZLB8X_AiIfQt4aym0p","title":"wnQk9KUWdiGze9HiHF2G","scroll":"dSghV81wqTZYSFiumJjF","header":"KhIvFUGm3F8oGLZj5uTJ"};